import {render} from 'react-dom'
import CollectionProductGrid from "./collection-grid-product/CollectionProductGrid";

const collectionProductGrid = document.getElementById('collection-product-grid');
if (collectionProductGrid) {
  render(<CollectionProductGrid type={'collection'} />, collectionProductGrid as HTMLElement);
}

const searchProductGrid = document.getElementById('search-product-grid');
if (searchProductGrid) {
  render(<CollectionProductGrid type={'search'} />, searchProductGrid as HTMLElement);
}

const pageflyHeader = document.querySelector('body.template-collection [id*=__pf-]') as HTMLElement;
if (pageflyHeader) {
  pageflyHeader.style.marginBottom = '80px';
}
